import { render, staticRenderFns } from "./WebhookUpdate.vue?vue&type=template&id=47eb4df5&"
import script from "./WebhookUpdate.vue?vue&type=script&lang=ts&"
export * from "./WebhookUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports